import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import routes from './Routes';
import ApolloServiceProvider from './ApolloServiceProvider';
import ApolloContextProvider from './ApolloContextProvider';
import ApolloServiceClient from './common/clients/ApolloServiceClient';
import AuthProvider from './common/auth/AuthProvider';

const Root = ({ store, history }) => {
    React.useEffect(() => {
        ApolloServiceClient.setStore(store);
    }, [store]);

    return (
        <ApolloServiceProvider>
            <Provider store={store}>
                <AuthProvider>
                    <ApolloContextProvider>
                        <ConnectedRouter history={history}>{routes}</ConnectedRouter>
                    </ApolloContextProvider>
                </AuthProvider>
            </Provider>
        </ApolloServiceProvider>
    );
};

Root.propTypes = {
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

export default Root;
